import React from "react";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton,
  FormControl,
  Select,
  MenuItem
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { sdmTableStyles, getHeaderCellStyle } from "./sdmTableStyles";

const RATING_OPTIONS = ["отл", "хор", "удовл", "неуд", "плох"];

const ManagementQualityTable = ({ data, onChange }) => {
  const rows = data?.rows || [];
  const selectorValue = data?.selector || "";

  const handleCellChange = (rowIndex, field, value) => {
    const updatedRows = rows.map((row, index) => {
      if (index === rowIndex) {
        return { ...row, [field]: value };
      }
      return row;
    });
    onChange({ ...data, rows: updatedRows });
  };

  const handleAddRow = () => {
    const newRow = {
      title: "",
      age: "",
      experience: "",
      education: "",
      lastJobs: ""
    };
    onChange({ ...data, rows: [...rows, newRow] });
  };

  const handleDeleteRow = (rowIndex) => {
    const updatedRows = rows.filter((_, index) => index !== rowIndex);
    onChange({ ...data, rows: updatedRows });
  };

  const handleSelectorChange = (value) => {
    onChange({ ...data, selector: value });
  };

  const columns = [
    { label: "Должность / ФИО / компания", minWidth: 250 },
    { label: "Возраст, лет", minWidth: 100 },
    { label: "Стаж в компании", minWidth: 120 },
    { label: "Образование (указать учебное заведение)", minWidth: 250 },
    { label: "Последние 2 места работы", minWidth: 250 },
  ];

  return (
    <Box sx={sdmTableStyles.tableWrapper}>
      <Box sx={sdmTableStyles.headerSection}>
        <Box sx={{ ...sdmTableStyles.sectionTitle, display: "flex", alignItems: "center", gap: "12px" }}>
          <span>Качество менеджмента:</span>
          <FormControl size="small" sx={{ minWidth: "120px" }}>
            <Select
              value={selectorValue}
              onChange={(e) => handleSelectorChange(e.target.value)}
              displayEmpty
              sx={sdmTableStyles.selectField}
            >
              <MenuItem value="">
                <em>-</em>
              </MenuItem>
              {RATING_OPTIONS.map((option, index) => (
                <MenuItem key={index} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>

      <TableContainer
        component={Paper}
        elevation={0}
        sx={sdmTableStyles.tableContainer}
      >
        <Table size={sdmTableStyles.tableSize}>
          <TableHead>
            <TableRow sx={sdmTableStyles.headerRow}>
              {columns.map((headCell, index) => (
                <TableCell
                  key={index}
                  sx={getHeaderCellStyle(headCell.minWidth)}
                >
                  {headCell.label}
                </TableCell>
              ))}
              <TableCell sx={sdmTableStyles.emptyCell} />
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow key={rowIndex} sx={sdmTableStyles.dataRow}>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.title || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'title', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    multiline
                    minRows={1}
                    sx={sdmTableStyles.textFieldMultiline}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.age || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'age', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={sdmTableStyles.textField}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.experience || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'experience', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={sdmTableStyles.textField}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.education || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'education', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    multiline
                    minRows={1}
                    sx={sdmTableStyles.textFieldMultiline}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.lastJobs || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'lastJobs', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    multiline
                    minRows={1}
                    sx={sdmTableStyles.textFieldMultiline}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <IconButton
                    size="small"
                    onClick={() => handleDeleteRow(rowIndex)}
                    sx={sdmTableStyles.deleteButton}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell colSpan={6} sx={sdmTableStyles.addRowCell}>
                <Button
                  fullWidth
                  onClick={handleAddRow}
                  startIcon={<AddCircleIcon />}
                  sx={sdmTableStyles.addRowButton}
                >
                  Добавить строку
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ManagementQualityTable;
